module.exports = __webpack_public_path__ + "static/noticias-21-c2cac449eb9cfce64555d791913e723b.jpg";